import overapi from "../../../../assets/img/programming/overapi.webp";
import cheatography from "../../../../assets/img/programming/cheatography.webp";
import educba from "../../../../assets/img/programming/educba.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";

export const DataDoc = [
  {
    title: "OverAPI",
    path: "https://overapi.com/java",
    icon: overapi,
    cName: "icon",
    description: "Collecting All Cheat Sheets. Big cheatsheets ressources.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "Cheatography",
    path: "https://cheatography.com/son9912/cheat-sheets/java-oop-concept/",
    icon: cheatography,
    cName: "icon",
    description:
      "Over 3,500 Free Cheat Sheets, Revision Aids and Quick References. You can create yours.",
  },
  {
    title: "Educba",
    path:
      "https://www.educba.com/software-development/software-development-tutorials/java-tutorial/",
    icon: educba,
    cName: "icon",
    description: "Java tutorial.",
  },
];
